// Old Code

// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { store } from '../../Store/store';

// const ProtectedRoute = ({ children }) => {
//   //debugger;
//   const userInfo = store.getState();

//   const location = useLocation();
//   const currentPath = location.pathname.toLowerCase();

//   const allowedPaths = userInfo.MenuData?.flatMap(menu => {
//   const mainPath = menu.URL?.toLowerCase();
//   const subPaths = menu.SubMenus?.map(sub => sub.URL?.toLowerCase()) || [];
//   return [mainPath, ...subPaths];
//   }) || [];

//   const isAuthorized = allowedPaths.includes(currentPath);

//   return isAuthorized ? children : <Navigate to="/authorize" replace />;
// };

// export default ProtectedRoute;

// New Code for OTP Protected Pages
import React, { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { store } from "../../Store/store";
import CommonOTPModal from "../../Common/CommonOTPModal";

const ProtectedRoute = ({ children }) => {
  const [isVerified, setIsVerified] = useState(false);
  const [requiresOtp, setRequiresOtp] = useState(false);
  const [storageKey, setStorageKey] = useState("");
  const [currentMenu, setCurrentMenu] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const userInfo = store.getState();
  const menuData = userInfo.MenuData || [];

  const currentPath = location.pathname.replace(/\/$/, "").toLowerCase();

  const allMenus = menuData.flatMap((menu) => [
    { ...menu, parent: null },
    ...(menu.SubMenus || []).map((sub) => ({ ...sub, parent: menu })),
  ]);

  const allowedPaths =
    allMenus.map((m) => m.URL?.replace(/\/$/, "").toLowerCase()).filter(Boolean) || [];

  const isAuthorized = allowedPaths.includes(currentPath);

  useEffect(() => {
    if (!isAuthorized) return; 

    const foundMenu = allMenus.find(
      (m) => m.URL && m.URL.replace(/\/$/, "").toLowerCase() === currentPath
    );
    setCurrentMenu(foundMenu || null);

    if (foundMenu?.Is_Otp && userInfo.userData.Role_Name != "Sales-Admin") {
      setRequiresOtp(true);
      const key = `otp:${currentPath}`;
      setStorageKey(key);

      const stored = sessionStorage.getItem(key);
      if (stored) {
        try {
          const { verified }= JSON.parse(stored);
          if (verified) {
            setIsVerified(true);
          } else {
            sessionStorage.removeItem(key);
            setIsVerified(false);
          }
        } catch {
          sessionStorage.removeItem(key);
          setIsVerified(false);
        }
      } else {
        setIsVerified(false);
      }
    } else {
      setRequiresOtp(false);
      setIsVerified(true);
    }
  }, [location.pathname, isAuthorized]);

  if (!isAuthorized) {
    return <Navigate to="/authorize" replace />;
  }

  if (requiresOtp && !isVerified) {
    return (
      <CommonOTPModal
        storageKey={storageKey}
        menuName={currentMenu?.MenuName}
        onSuccess={(data) => {
          if (data?.verified) {
            setIsVerified(true);
          } else {
            navigate("/dashboard", { replace: true });
          }
        }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
